/*  MUI  */
import { Box, Paper, Typography } from '@mui/material';

/* Shared */
import { PartnerBackButton } from 'application/Shared/Components/Buttons/BackButton';

/*  React  */
import React from 'react';

import { PartnerIntegrationWizard } from './PartnerIntegrationWizard';

export const PartnerIntegrationWizardWrapper = ({
    onboarding,
    headerTitle,
    steps,
    sharedData,
    cancelLink,
    saving
}) =>
    onboarding ? (
        <PartnerIntegrationWizard
            steps={steps}
            sharedData={sharedData}
            cancelLink={cancelLink}
            loading={saving}
        />
    ) : (
        <Box data-testid="partnerIntegrationWizardWrapper">
            <Box
                width="100%"
                data-testid="partnerIntegrationWizardWrapperTitle"
            >
                <Typography variant="h3">{headerTitle}</Typography>
                <hr />
            </Box>
            <PartnerBackButton
                linkTo="/integrations/partnerLevel"
                textOverride="Integrations.Common.back"
            />
            <Paper elevation={0} variant="outlined" style={{ padding: '16px' }}>
                <PartnerIntegrationWizard
                    steps={steps}
                    sharedData={sharedData}
                    cancelLink={cancelLink}
                    loading={saving}
                />
            </Paper>
        </Box>
    );
